import { v4 as uuidv4 } from "uuid";
import { supabase } from "../supabase";

let currentQueueCardId = "";
let followingQueueCardId = "";
// storing the collection filter as different types for different backend call
let collectionsFilterAsText = ''
let collectionsFilterAsList = [];
// used only to get pack name of card
let collectionsFilterAsObjectList = [];

// SUPABASE RPC RANDOM 
async function getRandomDueCard(rpc, typeFilter) {
  console.log("getting random due card...of types: ", typeFilter)

  let randomId = '';
  console.log(`calling rpc ${rpc} with type filter ${typeFilter} and collections filter ${collectionsFilterAsList}, due: ${new Date() / 1000}, user_id: ${supabase.auth.currentUser.id}`)

  const { data, error } = await supabase.rpc(
    "get_random_due_card",
    {
      id_of_user: supabase.auth.currentUser.id,
      type_filter: typeFilter,
      collections_filter: collectionsFilterAsList,
      due: new Date() / 1000,
    });
  console.log('got data from rpc', data)

  if (data.length > 0) {
    randomId = data[0].id;
  }
  console.log("got random id: ", randomId)

  if (randomId) {
    const { data, error } = await supabase
      .from("cards")
      .select()
      .eq("id", randomId)
      .match({ user_id: supabase.auth.currentUser.id });
    console.log(`returning random card of type ${typeFilter}:`, data);
    return data;

  } else {
    console.log(`no random card of type ${typeFilter} found, returning empty array`);
    return [];
  }
}

async function getLearnCard() {
  console.log('execute function getLearnCard()')
  if (Math.random() < 0.1) {

    return await getRandomDueCard("get_random_card_id_new", ['learn']);
  } else {
    return await getRandomDueCard("get_random_card_id_old", ['learn']);
  }

}

async function getPriorityCard() {
  console.log('execute function getPriorityCard()')
  const { error, data } = await supabase
    .from("cards")
    .select()
    .eq("priority", "true")
    .filter("pack_id", "in", collectionsFilterAsText)
    .lt("nextShown", +new Date() / 1000)
    .neq("id", currentQueueCardId)
    .neq("id", followingQueueCardId)
    .limit(1)
    .match({ user_id: supabase.auth.currentUser.id });
  console.log('priority card function returned:', data);
  return data;
}

async function getReadingListCard() {
  console.log('execute function getReadingListCard()')
  // we are grouping articles and books here
  if (Math.random() >= 0.3) {
    console.log('picking article...')
    const { error, data } = await supabase
      .from("cards")
      .select()
      .eq("type", "articleList")
      .filter("pack_id", "in", collectionsFilterAsText)
      .lt("nextShown", +new Date() / 1000)
      .neq("id", currentQueueCardId)
      .neq("id", followingQueueCardId)
      .limit(1)
      .match({ user_id: supabase.auth.currentUser.id });
    console.log('returning article', data);
    return data;
  } else {
    console.log('picking book...')
    // check how many active reading List cards we have
    // card.interval = 0 > active, card.interval = 1 > inactive
    // first, count the number of active cards the user has
    const { error, data } = await supabase
      .from("cards")
      .select("id")
      .eq("type", "readingList")
      .eq("startedReading", true)
      .filter("pack_id", "in", collectionsFilterAsText)
      .match({ user_id: supabase.auth.currentUser.id });

    console.log('got counting data', data);
    const activeCardsCount = data.length;
    console.log('active cards count: ', activeCardsCount);

    // if we have less than 3 active cards, we want to get a new one
    if (activeCardsCount < 5) {
      console.log(`active cards: ${activeCardsCount}, getting one that is not started yet`);
      const { error, data } = await supabase
        .from("cards")
        .select()
        .eq("type", "readingList")
        .filter("pack_id", "in", collectionsFilterAsText)
        .eq("startedReading", false)
        .neq("id", currentQueueCardId)
        .neq("id", followingQueueCardId)
        .limit(1)
        .match({ user_id: supabase.auth.currentUser.id });
      console.log('returning the following inactive/new book', data);
      return data;
    } else {
      console.log(`active cards: ${activeCardsCount}, getting an already started one`);
      const { error, data } = await supabase
        .from("cards")
        .select()
        .eq("type", "readingList")
        .eq("startedReading", true)
        .lt("nextShown", +new Date() / 1000)
        .neq("id", currentQueueCardId)
        .neq("id", followingQueueCardId)
        .filter("pack_id", "in", collectionsFilterAsText)
        .limit(1)
        .match({ user_id: supabase.auth.currentUser.id });

      console.log('returning the following active/started book', data);
      return data;
    }
  }
}

async function getCardRecursively(typeToGet, card_data = []) {
  console.log('typeToGet', typeToGet)
  if (typeToGet == "learn") {
    card_data = await getLearnCard(["learn"])
  } else if (typeToGet == "htc") {
    card_data = await getRandomDueCard("get_random_card_with_type_filter", ["habit", "todo", "check"])
  } else if (typeToGet == "readingList") {
    card_data = await getReadingListCard()
  } else if (typeToGet == "standard") {
    card_data = await getRandomDueCard("get_random_card_with_type_filter", ["standard"])
  }

  console.log('(about to call recursive stuff; got card data', card_data)

  if (card_data.length === 0) {
    console.log("no card found, trying again recursively")
    if (typeToGet == "learn") {
      console.log("have found no learn card, trying to get htc")
      card_data = await getCardRecursively("htc")
    } else if (typeToGet == "htc") {
      console.log("have found no htc card, trying to get readingList")
      card_data = await getCardRecursively("readingList")
    } else if (typeToGet == "readingList") {
      console.log("have found no readingList card, trying to get standard")
      card_data = await getCardRecursively("standard")
    } else if (typeToGet == "standard") {
      console.log("have found no standard card, trying to get learn")
      card_data = await getCardRecursively("learn")
    }
  }
  return card_data
}


export async function pickCard(state, cardToPick) {



  // if currentQueueCard exist, save its id, otherwise set the id to '---'
  currentQueueCardId = state.currentQueueCard
    ? state.currentQueueCard.id
    : uuidv4();

  // store next queue card as well
  followingQueueCardId = state.followingQueueCard
    ? state.followingQueueCard.id
    : uuidv4();


  // get active packs
  let { error: error3, data: data3 } = await supabase
    .from("packs")
    .select("id, name")
    .match({ user_id: supabase.auth.currentUser.id, isDisabled: false });

  // generate a collectionsFilterAsList array for querying only valid cards out of these collections
  collectionsFilterAsList = data3.map((collection) => collection.id);
  collectionsFilterAsText = '("' + collectionsFilterAsList.join('","') + '")';
  collectionsFilterAsObjectList = data3;

  // MAIN - MAIN
  let card_data = [];

  // check for project_card_datetime in localStorage
  // if longer than 16 hours ago (or doesn't exist), pick card of type project
  const projectCardDateTime = localStorage.getItem("project_card_datetime");
  let diffHours = 9999;
  if (projectCardDateTime) {
    const projectCardDateTimeAsDate = new Date(projectCardDateTime);
    const now = new Date();
    const diff = now.getTime() - projectCardDateTimeAsDate.getTime();
    diffHours = diff / (1000 * 3600);
    console.log("diffHours", diffHours);
  }
  if (diffHours > 16) {
    console.log("diffHours > 16, getting project card");
    card_data = await getRandomDueCard("get_random_card_with_type_filter", ["project"])
    // if we get a project card, we want to set the project_card_datetime to now
    if (card_data.length > 0) {
      console.log("setting project_card_datetime to now");
      localStorage.setItem("project_card_datetime", new Date());
    }
  }

  if (card_data.length == 0) {

    // with a chance of 75%, try to pick a priority card (when they are non left we will get an empty array and continue)
    if (Math.random() < .3) {
      card_data = await getPriorityCard()
    }

    if (card_data.length == 0) {

      let typeToGet = "";

      if (cardToPick.type <= 2) {
        typeToGet = "learn";
      } else if (cardToPick.type == 3) {
        typeToGet = "htc";
      } else if (cardToPick.type == 4) {
        typeToGet = "readingList";
      } else if (cardToPick.type == 5) {
        typeToGet = "standard";
      }

      card_data = await getCardRecursively(typeToGet)
    }
  }

  if (card_data.length !== 0) {
    let card = card_data[0];
    // for the card cards, set card.pack_name to the name of the pack it belongs to, as referenced by pack_id
    // use the existing data object to match the name to the id
    console.log(`card found, looking for pack name for pack id ${card.pack_id} in ${collectionsFilterAsList}`)
    console.log('data type of collectionsFilterAsList', typeof collectionsFilterAsList)
    const pack = collectionsFilterAsObjectList.find((pack) => pack.id === card.pack_id);
    console.log('found pack', pack)
    card["pack_name"] = pack.name;
    console.log("card found and supplied pack_name:", card);
    return card;
  }
  else {
    console.error("No card found");
  }
}
